import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import { Block } from "./TabBodyContentBlock.styles";
export var TabBodyContentBlock = function(param) {
    var children = param.children, _content = param.content, currentTab = _content.currentTab, subModule = _content.subModule, tabGroup = _content.tabGroup, rules = param.rules;
    var name = subModule.name, position = subModule.position;
    var ref = rules || {}, _textStyle = ref.textStyle, textStyle = _textStyle === void 0 ? Ui.RichTextStyle.Primary : _textStyle;
    return /*#__PURE__*/ _jsx(Block, {
        isHidden: currentTab !== name,
        id: "".concat(tabGroup, "-panel-").concat(position),
        "aria-labelledby": "".concat(tabGroup, "-tab-").concat(position),
        role: "tabpanel",
        tabIndex: 0,
        textStyle: textStyle,
        children: children(subModule.module)
    }, name);
};
